(function () {
  'use strict';

  if (typeof Shopify === 'undefined') return;
  var _isDesignMode = Shopify.designMode;

  var E = 'https://ddgwopkzrbpbfzsckwoc.supabase.co/functions/v1/validate';
  var S = 'inspd_s';
  var T = 3600000;
  var V = '4.2.0';

  function gc(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }

  function sc(n, v, ms) {
    var d = new Date(Date.now() + ms);
    document.cookie = n + '=' + v + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function rp() {
    var els = document.querySelectorAll('[data-pro-feature]');
    for (var i = 0; i < els.length; i++) {
      els[i].style.display = 'none';
      els[i].setAttribute('aria-hidden', 'true');
    }
  }

  var _fc = [84,104,101,109,101,32,98,121,32];
  var _fn = [73,110,115,112,105,114,101,100,84,104,101,109,101];
  var _fu = [104,116,116,112,115,58,47,47,105,110,115,112,105,114,101,100,116,104,101,109,101,46,99,111,109,47];
  var _fd = [105,110,115,112,105,114,101,100,116,104,101,109,101];
  var _bt = [66,117,121,32,116,104,101,109,101,32,111,110,32];
  var _bu = [104,116,116,112,115,58,47,47,105,110,115,112,105,114,101,100,116,104,101,109,101,46,99,111,109];
  var _bl = [85,112,103,114,97,100,101,32,110,111,119,32,116,111,32,117,110,108,111,99,107,32,116,104,101,32,116,104,101,109,101];
  var _ur = [104,116,116,112,115,58,47,47,117,112,103,114,97,100,101,46,105,110,115,112,105,114,101,100,116,104,101,109,101,46,99,111,109];

  function _ds(a) { return a.map(function (c) { return String.fromCharCode(c) }).join('') }

  function _cm() {
    var t = _ds(_fc), n = _ds(_fn), u = _ds(_fu), d = _ds(_fd);
    var el = document.querySelector('.ft-m[data-c]');
    if (!el) {
      var cp = document.querySelector('.footer__copyright');
      if (cp) {
        el = document.createElement('span');
        el.className = 'ft-m';
        el.setAttribute('data-c', '1');
        cp.appendChild(el);
      }
    }
    if (!el) return;

    var existing = el.querySelector('a');
    if (existing && existing.href.indexOf(d) !== -1 && existing.textContent.indexOf(n) !== -1) return;

    el.innerHTML = '';
    var s = document.createElement('small');
    s.className = 'copyright__content';
    s.style.textTransform = 'uppercase';
    var a = document.createElement('a');
    a.href = u;
    a.style.textDecoration = 'none';
    a.style.color = 'inherit';
    a.textContent = ' \u2014 ' + t + n;
    s.appendChild(a);
    el.appendChild(s);
  }

  function _rm() {
    var el = document.querySelector('.ft-m[data-c]');
    if (el) el.innerHTML = '';
  }

  function _cf() {
    var cv = gc(S);
    if (cv === '1') { _rm(); } else { _rm(); }
  }

  var _mo_init = false;
  function _startMo() {
    if (_mo_init) return;
    var ft = document.querySelector('.footer__copyright');
    if (!ft) return;
    _mo_init = true;
    new MutationObserver(function () {
      if (gc(S) !== '1') { setTimeout(_rm, 50); }
    }).observe(ft, { childList: true, subtree: true, characterData: true });
  }

  function _isPreview() {
    var k = window.__tk;
    return k && k.substring(0, 9) === 'INSP-PRV-';
  }

  var _src = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 .,-/:?@';

function _enc(idx) {
  var out = '';
  for (var i = 0; i < idx.length; i++) out += _src.charAt(idx[i]);
  return out;
}

function _showGate(reason) {
  if (document.getElementById('theme-gate-expired')) return;

  var overlay = document.createElement('div');
  overlay.id = 'theme-gate-expired';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(255,255,255,0.97);display:flex;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;';

  var title = _enc([50,14,20,17,62,41,17,4,21,8,4,22,62,33,0,18,62,30,13,3,4,3]);
  var desc = _enc([
    50,14,20,17,62,5,17,4,4,62,15,17,4,21,8,4,22,62,15,4,17,8,14,3,62,7,0,18,62,
    4,13,3,4,3,63,62,46,15,6,17,0,3,4,62,13,14,22,62,19,14,62,2,14,13,19,8,13,20,
    4,62,20,18,8,13,6,62,19,7,8,18,62,19,7,4,12,4,63
  ]);
  var footer = _enc([
    42,20,4,18,19,8,14,13,18,68,62,28,14,13,19,0,2,19,62,19,17,0,2,24,69,8,13,18,
    15,8,17,4,3,19,7,4,12,4,63,2,14,12
  ]);

  var btnLabel = _ds(_bl);
  var linkUrl = _ds(_ur);

  overlay.innerHTML = '<div style="max-width:420px;width:90%;text-align:center;padding:40px 32px;">'
    + '<div style="width:48px;height:48px;margin:0 auto 24px;border-radius:50%;background:#333A30;display:flex;align-items:center;justify-content:center;">'
    + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<circle cx="12" cy="12" r="9" stroke="#fff" stroke-width="1.5"/><path d="M12 7v5l3 3" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>'
    + '</svg></div>'
    + '<h2 style="margin:0 0 8px;font-size:22px;font-weight:600;color:#121212;line-height:1.3;">' + title + '</h2>'
    + '<p style="margin:0 0 24px;font-size:15px;line-height:1.6;color:rgba(18,18,18,0.55);">' + desc + '</p>'
    + '<a href="' + linkUrl + '" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:8px;padding:12px 28px;background:#333A30;color:#fff;text-decoration:none;border-radius:6px;font-size:14px;font-weight:500;">' + btnLabel + '</a>'
    + '<p style="margin:16px 0 0;font-size:12px;color:rgba(18,18,18,0.3);">' + footer + '</p>'
    + '</div>';

  document.body.appendChild(overlay);
}

  var _locking = false;
  function _lockButtons() {
    if (_locking) return;
    _locking = true;

    try {
      var label = _ds(_bl);
      var url = _ds(_ur);

      function transform(el) {
        if (el.getAttribute('data-_lk') === '1') return;
        el.setAttribute('data-_lk', '1');

        try { el.type = 'button'; } catch (e) {}
        el.removeAttribute('name');
        el.removeAttribute('disabled');
        el.removeAttribute('aria-disabled');
        el.style.pointerEvents = '';
        el.style.opacity = '';
        el.style.cursor = 'pointer';

        var tag = el.tagName;
        if (tag === 'BUTTON') {
          el.innerHTML = '';
          el.textContent = label;
        } else if (tag === 'A') {
          el.href = url;
          el.target = '_blank';
          el.rel = 'noopener';
          el.textContent = label;
        } else if (tag === 'INPUT') {
          el.value = label;
        }

        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.open(url, '_blank', 'noopener');
          return false;
        }, true);
      }

      var addBtns = document.querySelectorAll('button[name="add"]:not([data-_lk]), .product-form__submit:not([data-_lk]), .product-upsells__button--add-to-cart:not([data-_lk])');
      for (var i = 0; i < addBtns.length; i++) transform(addBtns[i]);

      var checkBtns = document.querySelectorAll('#checkout:not([data-_lk]), #CartDrawer-Checkout:not([data-_lk]), .cart__checkout-button:not([data-_lk])');
      for (var j = 0; j < checkBtns.length; j++) transform(checkBtns[j]);

      var dynamicBtns = document.querySelectorAll('.cart__dynamic-checkout-buttons:not([data-_lk]), .shopify-payment-button:not([data-_lk])');
      for (var d = 0; d < dynamicBtns.length; d++) {
        dynamicBtns[d].setAttribute('data-_lk', '1');
        dynamicBtns[d].style.display = 'none';
      }

      var forms = document.querySelectorAll('form[action*="/cart/add"]:not([data-_lkf])');
      for (var f = 0; f < forms.length; f++) {
        forms[f].setAttribute('data-_lkf', '1');
        forms[f].addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.open(url, '_blank', 'noopener');
          return false;
        }, true);
      }
    } finally {
      _locking = false;
    }
  }

  var _btnObserver = null;
  var _btnTimer = null;
  function _watchButtons() {
    if (_btnObserver) return;
    _btnObserver = new MutationObserver(function () {
      if (_locking) return;
      if (_btnTimer) return;
      _btnTimer = setTimeout(function () {
        _btnTimer = null;
        if (gc(S) !== '1') { _lockButtons(); }
      }, 250);
    });
    _btnObserver.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      if (_btnObserver) {
        _btnObserver.disconnect();
        _btnObserver = null;
      }
    }, 10000);
  }

  function vk() {
    if (_isDesignMode) return;
    var c = gc(S);
    if (c === '1') { _cf(); _startMo(); return; }
    if (c === '0') {
      rp();
      if (_isPreview()) {
        _showGate();
        _lockButtons();
        _watchButtons();
      }
      _cf();
      _startMo();
      return;
    }

    var k = window.__tk;
    if (!k) { _cf(); _startMo(); return; }

    var sd = Shopify.shop || '';
    if (!sd) { _cf(); _startMo(); return; }

    var u = E + '?key=' + encodeURIComponent(k) + '&shop=' + encodeURIComponent(sd) + '&v=' + V;

    var x = new XMLHttpRequest();
    x.open('GET', u, true);
    x.timeout = 8000;
    x.onload = function () {
      try {
        var r = JSON.parse(x.responseText);
        if (r.valid === true) {
          sc(S, '1', T);
        } else {
          sc(S, '0', T);
          rp();
          if (r.trial_type === 'preview') {
            _showGate(r.reason);
            _lockButtons();
            _watchButtons();
          }
        }
      } catch (e) {
        sc(S, '1', T);
      }
      _cf();
      _startMo();
    };
    x.onerror = function () {
      sc(S, '1', T);
      _cf();
      _startMo();
    };
    x.ontimeout = function () {
      sc(S, '1', T);
      _cf();
      _startMo();
    };
    x.send();
  }

  function validateLicenseStatus(licenseKey, shopDomain) {
    var apiBase = '/apps/theme-auth/verify';
    var checksum = 0;
    for (var i = 0; i < licenseKey.length; i++) {
      checksum = ((checksum << 5) - checksum + licenseKey.charCodeAt(i)) | 0;
    }
    var endpoint = apiBase + '?token=' + encodeURIComponent(licenseKey) + '&store=' + encodeURIComponent(shopDomain) + '&cs=' + checksum;
    return { url: endpoint, ready: false };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vk);
  } else {
    vk();
  }

  setInterval(function () {
    if (gc(S) !== '1') { _rm(); }
  }, 5000);
})();